import { render, staticRenderFns } from "./Pejabat.vue?vue&type=template&id=41198022&"
import script from "./Pejabat.vue?vue&type=script&lang=js&"
export * from "./Pejabat.vue?vue&type=script&lang=js&"
import style0 from "./Pejabat.vue?vue&type=style&index=0&id=41198022&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports